import { EZModule } from '../../classes/v2/EZModule';
import Handlebars, { log } from 'handlebars';
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import { modules } from '../../main';

declare let ezentrum_artikel_config: {
    filter_main: any;
    next_start_position: any;
    product_data: string;
    records_to_follow: number;
    mandant_next_load: number;
    filter_options: any;
    records_in_list: number;
    query_id: number;
    filter_Settings: Array<Object>;
};

export default class ArtikelFilter extends EZModule {

    private static yaml: any; // yaml data
    private fetchResult:any;
    private containerEle:HTMLElement;
    private activeObject: Array<any>;
    private languageName: string;
    private filterSettings:Array<Object> | null; // Actual object

    /** @param configuration = part of the yaml with ArtikelFilter */
    public constructor(configuration:any ) {
        super(configuration);
        ArtikelFilter.yaml = configuration;
    }

    public async init(): Promise<void> {
        try {
            this.fetchResult = null;
            this.activeObject = new Array();
            this.containerEle = document.querySelector('.ez-artikelfilter');
            this.fetchResult = ezentrum_artikel_config.filter_options;
            this.languageName = modules.getLanguageCode();
            this.filterSettings = ezentrum_artikel_config.filter_Settings || null;
            if ( this.fetchResult ) {
                this.createFilter();
                this.loadMoarButton();
            }
        } catch (error) {
            console.error('Error during initialization:', error);
        }
    }

    /** @Chris @description Start of the creation */
    private createFilter() {
        const excludeFilter: Set<string> = new Set( ArtikelFilter.yaml.config.excludeFilter );
        const chosenOrder: Set<string> = new Set(ArtikelFilter.yaml.config?.template_filter_order);
        const chosenOrderContent: Array<string> = new Array( chosenOrder.size );
        const sliderArray: Set<string> = new Set( ArtikelFilter.yaml.config.slider );
        const isSlider = ( key: string ) => sliderArray.has( key );
        const checkboxTemplate: HandlebarsTemplateDelegate<string> = Handlebars.compile(ArtikelFilter.yaml.components.html.checkbox);
        const sliderTemplate: HandlebarsTemplateDelegate<string> = Handlebars.compile(ArtikelFilter.yaml.components.html.slider);
        const splitOutput:boolean = ArtikelFilter.yaml.config.splitOutput;

        const generateHTML = ( contentObj: any ) => {
            return isSlider( Object.keys( contentObj )[0] )
                ? this.generateHTMLPiece( contentObj, sliderTemplate, 'slider'  )
                : this.generateHTMLPiece( contentObj, checkboxTemplate );
        };

        const processKey = ( key: string ) => {
            const array = this.fetchResult[ key ];
            this.modifyContent( array, excludeFilter, key );
            const contentObj = { [ key ] : this.fetchResult[ key ] };
            return contentObj;
        };

        for ( const key of Object.keys( this.fetchResult ) ) {
            const contentObj = processKey( key );

            if ( chosenOrder?.size > 0 && chosenOrder?.has( key ) ) {
                const index = Array.from( chosenOrder  ).indexOf( key );
                if (contentObj[key].length > 0) chosenOrderContent[index] = generateHTML( contentObj );
            } else {
                if (contentObj[key].length > 0) chosenOrderContent.push( generateHTML( contentObj ) );
            }
        }

        // Get main filter, if exists
        if (this.activeObject.length > 0 ) this.checkMainFilter();

        if ( splitOutput ) {
            const splitOutputContainerEle = ArtikelFilter.yaml.components.html.splitContainer;
            this.containerEle.innerHTML += splitOutputContainerEle;

            const mainAmount: number = ArtikelFilter.yaml.config.mainFilterAmount;
            const mainFilters = chosenOrderContent.slice(0, mainAmount ).join('');
            const additionalFilters = chosenOrderContent.slice( mainAmount , chosenOrderContent.length ).join('');
            const mainFilterEle = this.containerEle.querySelector('#main_filter');
            const additionalFilterEle = this.containerEle.querySelector('#additional_filter');
            mainFilterEle.innerHTML = mainFilters;
            additionalFilterEle.innerHTML = additionalFilters;
        }
        else {
            const appendHTML = chosenOrderContent.join( '' );
            this.containerEle.innerHTML = appendHTML;
        }
        this.afterCreation();
    }


    /** @Chris Stuff that happens after the content has been placed */
    private afterCreation() {
        this.renameGroupTitle();
        this.setState();
        this.setActiveFormParams();
        this.createScrollForMoreEle();
        this.checkboxLister();
        this.createSlider();
        this.updateSliderListener();
        this.activeSliderListener();
    }

    /** @Chris
     * @description Modifiying the data before creating them
     * Excluding values that shall not be seen
     * Additionally creating a static name of the value strings that doesn't contain any spaces -> " "
     */
    private modifyContent(array:Array<any>, excludeFilter:Set<string>, key:string):void {
        const newArray = array.filter(obj => 'value' in obj ? !excludeFilter.has(obj.value) : true);
        const adjustedArray = this.adjustValue(newArray, key)
        this.fetchResult[key] = adjustedArray;
        for ( const obj of adjustedArray ) { // Iterate over the filtered array to add static_name property
            this.checkState(obj, key);
        }
    }

    private adjustValue(arr:Array<any>, key:string):Array<any> {

        if (arr.length > 2 || arr.length === 0 ) return arr;

        const currFilterObjNumber:number = Number(this.fetchResult[key][0].id.split('_')[0]);
        const settings:any | undefined = this.filterSettings.find(( obj:any )=> obj.id === currFilterObjNumber );
        if ( typeof settings === 'undefined' || settings.display_on === '') return arr;

        if (arr.length === 2) {
            arr[0].displayName = settings.display_off;
            arr[1].displayName = settings.display_on;
        }
        else {
            arr[0].displayName =  arr[0].value === 'Falsch' ? settings.display_off : settings.display_on;
        }
        return arr;
    }


    /** @Chris
     * @description returning the finished html
     * @param object = data
     * @param type = template for either checkboxes or slider
     * @returns = HTML as a string
     */
    private generateHTMLPiece(object:any, templateType:HandlebarsTemplateDelegate<string>, key?:string):string {
        const currentObj = object[ Object.keys( object )[ 0 ]] [ 0 ];
        if ( currentObj.filtertype !== undefined && currentObj.min_value === currentObj.max_value) return;
        return templateType( object );
    }

    /** @Chris @description Checking whether the checkbox shall be activated */
    private checkState(object: { displayName: any; display: string; max_value: number; min_value: number; filtertype?: string; checked?: boolean; value: string; id: string }, key: string): void {
        if ( !object.checked ) return;
        const isRangedSlider = object.filtertype !== undefined;
        let currentEntry = this.activeObject.find( obj => obj.attribute === key );

        const currFilterObjNumber:number = Number(this.fetchResult[key][0].id.split('_')[0]);
        const differentName:any = this.filterSettings.find( (obj:{ id:number } ) => obj.id === currFilterObjNumber);
        const differentAttributeName = differentName !== undefined ? differentName.name : null;

        // New entry, create empty shell
        if ( !currentEntry ) {
            currentEntry = { active_filters: [], attribute: key, id: [], filtertype: undefined };
            if ( differentAttributeName ) currentEntry.attributeName = differentAttributeName;
            this.activeObject.push( currentEntry );
        }

        if ( isRangedSlider ) {
            currentEntry.active_filters.push(object.min_value.toString());
            currentEntry.active_filters.push(object.max_value.toString());
            currentEntry.filtertype = 'ranged';
            currentEntry.id = [object.id];
            currentEntry.display = object.display;
        } else {
            currentEntry.active_filters.push(object.value);
            currentEntry.id.push(object.id);
        }
    }

    /** @Chris @description Switching the position of the main filter with the first filter found */
    private checkMainFilter():void {
        const mainFilter = ezentrum_artikel_config.filter_main || '';
        if ( mainFilter ===  '') return;

        const index = this.activeObject.findIndex( obj => obj.attribute === mainFilter );
        if ( index === -1 || index === 0) return;

        const mainFilterObj = this.activeObject[index];
        this.activeObject.splice( index, 1 );
        const firstFilter = this.activeObject[0];

        this.activeObject.push(firstFilter);
        this.activeObject[0] = mainFilterObj;
    }

    /** @Chris @description Pulling the switch on the checkboxes */
    private setState(): void {
        if ( this.activeObject.length <= 0 ) return;

        const template: HandlebarsTemplateDelegate<string> = Handlebars.compile( ArtikelFilter.yaml.components.html.activeFilter );
        const activeFilterContainer = document.getElementById( 'ez_activeFilterContainer' );

        for ( const obj of this.activeObject ) {
            for (let i = 0; i < obj.active_filters.length; i++) {
                const tempEle: HTMLInputElement = document.getElementById( obj.id[i] ) as HTMLInputElement;
                if ( tempEle ) tempEle.checked = true;
            }
            if ( !activeFilterContainer ) continue;
            this.fillActiveFiltersBox( activeFilterContainer, obj, template);
        }
    }

    /** @Chris
     * @description Fills an html element with labels, that can be used instead of the inner filters
     * @param activeFilterContainer Container where the stuff goes
     * @param obj Object which holds one or more filters
     * @param template handlebars template
     */
    private fillActiveFiltersBox( activeFilterContainer:HTMLElement, obj:any, template: Handlebars.TemplateDelegate ):void {
        const activeUniqueFilter = obj;
        const uniqueFilterArray:any = [];
        if ( activeUniqueFilter.filtertype ) {
            uniqueFilterArray.push( {
                'minVal': activeUniqueFilter.active_filters[ 0 ],
                'maxVal': activeUniqueFilter.active_filters[ 1 ],
                'id': activeUniqueFilter.id,
                'attribute': activeUniqueFilter.attribute,
                'attributeName': activeUniqueFilter.attributeName,
                'filtertype': activeUniqueFilter.filtertype,
                'display': activeUniqueFilter.display
            });
        }
        else {
            activeUniqueFilter.active_filters.forEach( (filter:Array<any>, index:number) => {
                uniqueFilterArray.push( {
                        'active_filters': filter,
                        'id': activeUniqueFilter.id[index],
                        'attribute': activeUniqueFilter.attribute,
                        'attributeName': activeUniqueFilter.attributeName,
                        'filtertype': activeUniqueFilter.filtertype,
                        'display': activeUniqueFilter.display
                });
            });
        }
        activeFilterContainer.insertAdjacentHTML('beforeend', template( uniqueFilterArray as any ) );
    }

    private setActiveFormParams():void {
        const nextDataEle = document.getElementById('ez_nextData') as HTMLInputElement;
        if ( nextDataEle ) nextDataEle.value = new URLSearchParams( this.utoa( new TextEncoder().encode(JSON.stringify( this.createPostData() ) ) ) ) + '';
    }

    // Compares with the datas settings key
    private renameGroupTitle():void {
        if ( this.filterSettings.length <= 0 ) return;
        for ( const key of Object.keys( this.fetchResult ) ) {
            const titleEle:NodeListOf<HTMLElement> = this.containerEle.querySelectorAll(`[data-ez-groupname="${key}"]`);
            if ( titleEle.length === 0 ) continue;
            titleEle.forEach( title => {
                const currFilterObjNumber:number = Number(this.fetchResult[key][0].id.split('_')[0]);
                //OBJ
                const differentNameObj:any = this.filterSettings.find( (obj:{ id:number } ) => obj.id === currFilterObjNumber);
                title.textContent = differentNameObj.name;
            });
        }
    }

    /** @Chris @description CheckboxListener */
    private checkboxLister():void {
        const allFiltersArray:NodeListOf<HTMLInputElement> = this.containerEle.querySelectorAll( '[data-ez-filtercheckbox]' );
        allFiltersArray.forEach( ele => {
            ele.addEventListener('click', async ()=> await this.updateReload( ele ) );
        });
    }

    /** @Chris
     * @description Creating noUISlider objects that handle everything
     * TODO: Needs adjustment for the call later, to throw the range numbers correctly
     * */
    private createSlider():void {
        const sliderEle:NodeListOf<HTMLElement> = this.containerEle.querySelectorAll('[data-ez-slider]');
        for ( let i = 0; i  < sliderEle.length; i++ ) {
            const ele:HTMLElement = sliderEle[i];
            const filterName = ele.getAttribute( 'data-ez-slider' );
            const fetchContent = this.fetchResult[ filterName ];
            if ( !fetchContent ) continue;

            const container = document.createElement( 'div' );

            ele.appendChild( container );
            const status = document.createElement( 'div' );
            container.appendChild( status );
            const sliderElement = document.createElement( 'div' );
            container.appendChild( sliderElement );
            const tooltips = document.createElement( 'div' );
            container.appendChild( tooltips );

            const min = Number(fetchContent[ 0 ].min_value);
            const max = Number(fetchContent[ 0 ].max_value);
            const step = Number(fetchContent[ 0 ].step ) || 1;

            const thisSlider = noUiSlider.create( ele , {
                start: [ min, max],
                connect: true,
                step: step,
                tooltips: true,
                range: {
                    min: min,
                    max: max
                }
            });

            const numberInputField1:HTMLInputElement = document.getElementById(`${ele.id}_inputField1`) as HTMLInputElement;
            const numberInputField2:HTMLInputElement = document.getElementById(`${ele.id}_inputField2`) as HTMLInputElement;

            if ( numberInputField1 && numberInputField2 ) {
                thisSlider.on('update', function(values:any, handle:any) {
                    const value = values[handle];
                    if (handle === 0) numberInputField1.value = value;
                    else  numberInputField2.value = value;
                });
                numberInputField1.addEventListener('change', function() { thisSlider.set([this.value, null]); });
                numberInputField2.addEventListener('change', function() { thisSlider.set([null, this.value]); });
            }
        }
    }

    private updateSliderListener():void {
        const sliderConfirmButtonArray:NodeListOf<HTMLButtonElement> = document.querySelectorAll('.ez_slider_confirm');
        if ( !sliderConfirmButtonArray) return;

        sliderConfirmButtonArray.forEach( button => {
            button.addEventListener( 'click', () => {
                const thisButton = button;
                const groupName = thisButton.dataset.ezApplyGroup || '';
                const groupEle = document.getElementById(`toggle-${groupName}`);
                const lowerHandle:any = groupEle.querySelector('.noUi-handle-lower');
                const upperHandle:any = groupEle.querySelector('.noUi-handle-upper');
                if ( !lowerHandle || !upperHandle || groupName === '') return;
                const lowerHandleVal = lowerHandle.getAttribute('aria-valuenow');
                const upperHandleVal = upperHandle.getAttribute('aria-valuenow');

                const index = this.activeObject.findIndex( obj => obj.attribute === groupName);

                if ( index !== -1 ) {
                    this.activeObject[index].active_filters[0] = lowerHandleVal;
                    this.activeObject[index].active_filters[1] = upperHandleVal;
                }
                else {
                    this.activeObject.push( {
                        'attribute': groupName,
                        'active_filters': [
                            lowerHandleVal,
                            upperHandleVal
                        ]
                    });
                }
                this.sendForm();
            });
        });
    }

    /** @Chris @description adds listener for slider */
    private activeSliderListener():void {
        for( let i = 0; i < this.activeObject.length ; i++ ) {
            const currentIt = this.activeObject[i];
            if ( currentIt.filtertype === undefined ) continue;
            const activeSliderEle = document.querySelector(`[for="${currentIt.id[0]}"]`);

            if ( !activeSliderEle ) return;
            activeSliderEle.addEventListener( 'click', ()=> {
                this.activeObject.splice( i ,1 );
                this.sendForm();
            });
        }
    }

    /** @Chris
     * @description Activates the next URL to load to
     * @param pressedFilter Inputelement
     */
    private async updateReload(pressedFilter: HTMLInputElement):Promise<void> {
        const filterName = pressedFilter.name; // Getting the name, which might be seperated by spaces etc.
        const filterType:string = pressedFilter.closest('[data-ez-group]')?.getAttribute('data-ez-group') || undefined;
        const index = this.activeObject.findIndex( obj => obj.attribute === filterType);
        if ( pressedFilter.checked ) {
            if ( index !== -1 ) {
                this.activeObject[index].active_filters.push(filterName);
                this.activeObject[index].id.push(pressedFilter.id);
            }
            else {
                this.activeObject.push( {
                    'attribute': filterType,
                    'active_filters': [ filterName ],
                    'id': [ pressedFilter.id ]
                });
            }
        }
        else { // API-Call to less-filtered url
            if ( index !== -1 ) {
                if (this.activeObject[index].active_filters.length === 1) {
                    this.activeObject.splice( index, 1 );
                }
                else {
                    this.activeObject[index].active_filters.splice(this.activeObject[index].active_filters.findIndex( (filter:string) => filter === filterName), 1 );
                }
            }
        }
        this.sendForm();
    }

    /** @description Applying the set filters to the form */
    private sendForm():void {
        const nextDataEle = document.getElementById('ez_nextData') as HTMLInputElement;
        if ( nextDataEle ) nextDataEle.value = new URLSearchParams( this.utoa(new TextEncoder().encode(JSON.stringify( this.createPostData() ))) ) + '';
        const formEle = nextDataEle.closest('form');
        const action = formEle.querySelector('[name="action"]') as HTMLInputElement;
        action.value = 'ApplyFilter';
        formEle.submit();
    }

    private loadMoarButton():void {
        if ( !ezentrum_artikel_config?.mandant_next_load || ezentrum_artikel_config.mandant_next_load  <= 0) return;
        const loadMoar:HTMLButtonElement = document.getElementById('ez_loadMoar') as HTMLButtonElement;
        if ( !loadMoar ) return;
        if ( ArtikelFilter.yaml.config.customeLoadMoreText ) {
            if ( ezentrum_artikel_config.mandant_next_load < ezentrum_artikel_config.records_to_follow )
                loadMoar.textContent = ArtikelFilter.yaml.config.customeLoadMoreText.replace('{anzahl}', ezentrum_artikel_config.mandant_next_load).replace('{max_anzahl}',ezentrum_artikel_config.records_to_follow );
            else
                loadMoar.textContent = ArtikelFilter.yaml.config.customeLoadLastText.replace('{anzahl}', ezentrum_artikel_config.records_to_follow);
        }

        loadMoar.addEventListener('click', async ()=> {
            const postData:any = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                body: new URLSearchParams(this.dataCall('LoadNextPart'))
            };
            try {
                const res = await fetch('/4DCGI/ezshop', postData);
                if (res.ok) {
                    ezentrum_artikel_config = await res.json();
                    this.updateAfterLoadMoar();
                } else {
                    console.error('Error:', res.status, res.statusText);
                }
            } catch (error) {
                console.error('Error during fetch:', error);
            }

            if ( ezentrum_artikel_config.records_to_follow && ezentrum_artikel_config.records_to_follow <= 0 ) {
                loadMoar.classList.add( 'ez_hide_filterMoarButton' );
                loadMoar.setAttribute('data-ez-filterNoMoar', 'true');
            }
        });
    }

    private updateAfterLoadMoar():void {
        const articleListEle = document.querySelector('[data-ez-filter-outputcontainer]');
        if ( !articleListEle ) return;
        articleListEle.innerHTML += ezentrum_artikel_config.product_data !== undefined ? ezentrum_artikel_config.product_data : '<span>Fehler beim Laden!</span>';
        const loadMoar:HTMLButtonElement = document.getElementById('ez_loadMoar') as HTMLButtonElement;

        if ( ezentrum_artikel_config.records_to_follow > 0) { // If there may be some more article
            if ( ArtikelFilter.yaml.config.customeLoadMoreText ) {
                if ( ezentrum_artikel_config.mandant_next_load < ezentrum_artikel_config.records_to_follow)
                    loadMoar.textContent = ArtikelFilter.yaml.config.customeLoadMoreText.replace('{anzahl}', ezentrum_artikel_config.mandant_next_load).replace('{max_anzahl}',ezentrum_artikel_config.records_to_follow );
                else
                    loadMoar.textContent = ArtikelFilter.yaml.config.customeLoadLastText.replace('{anzahl}', ezentrum_artikel_config.records_to_follow);
            }
        }
        else { // no more articles to load
            if ( ArtikelFilter.yaml.components.html.noMoreArticle ) {
                const parentEle = loadMoar.parentElement;
                if ( !parentEle ) return;
                parentEle.innerHTML = ArtikelFilter.yaml.components.html.noMoreArticle.replace('{text}', ArtikelFilter.yaml.label[this.languageName].noMoreArticleText);
            }
        }
    }

    /** @Chris @description Creating 'Show more' element for each container whose scroll height is greater than their shown height */
    private createScrollForMoreEle():void {
        const buttonList = this.containerEle.querySelectorAll('[data-ez-groupname]');

        if (buttonList.length <= 0) return;

        buttonList.forEach( button => {
            button.addEventListener('click', ()=> {
                setTimeout( ()=> {
                    const filterContainer = document.getElementById(button.getAttribute('data-ez-groupname'));
                    if ( !filterContainer ) return;
                    const scrollHeight = filterContainer.scrollHeight;
                    const fixedHeight = Math.round(filterContainer.getBoundingClientRect().height); // Must be rounded to match scrollHeight

                    if ( scrollHeight <= fixedHeight ) return;
                    const showMoreEle = ArtikelFilter.yaml.components.html.scrollMore;
                    const filterContainerParent = filterContainer.parentElement;
                    filterContainerParent?.insertAdjacentHTML('beforeend', showMoreEle || '<span id="ez_scrollMore">Scrollen</span>');
                }, 300);
            }, { once:true} );
        });
    }

    private utoa(data:any) {
        const binString = String.fromCodePoint(...data);
        return btoa(binString);
    }

    private createPostData():any {
        return {
            query_id: ezentrum_artikel_config.query_id,
            start_pos: ezentrum_artikel_config.next_start_position,
            next_load: ezentrum_artikel_config.mandant_next_load,
            active_filter: this.activeObject
        };
    }

    private dataCall(action:string):any {
        const sortierwert:HTMLSelectElement = document.querySelector(`select[name="sortierfeld"]`);
        return {
            action: action,
            sKontaktKEY: modules.getKontaktKey(),
            sKontaktID: modules.getKontaktID(),
            sTICKCOUNT: modules.getTickcount(),
            Suchid: ezentrum_artikel_config.query_id,
            nextData: this.utoa( new TextEncoder().encode(JSON.stringify( this.createPostData() ) ) ),
            sortierfeld: sortierwert ? sortierwert.value : 0
        }
    }

    public run() {} // empty. Kept for compability.
    public getClass(): string { return 'ez-artikelfilter'; }/** @returns The class name of the HTML element that houses ArtikelFilter */
}